module.exports = __webpack_public_path__ + "static/people-2fd2f0b938fb805ce0d5d9da1f859287.webp";